import { render, staticRenderFns } from "./GClassManagementGroupTable.vue?vue&type=template&id=7403a6db&scoped=true&"
import script from "./GClassManagementGroupTable.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementGroupTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7403a6db",
  null
  
)

export default component.exports